module.exports = __webpack_public_path__ + "static/media/merit.cb2d4e3e.svg";